var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('b-img',{staticStyle:{"height":"180px"},attrs:{"src":"https://picsum.photos/300/180/?image=41","fluid-grow":"","alt":"Fluid-grow image"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }